<template>
  <div id="app">
    <b-navbar
        toggleable="md"
        type="light"
    >
      <b-navbar-brand href="/"><b-img :src="`${publicPath}navbar-logo.svg`" height="80"/></b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <h6 class="navbar-title ml-auto blue">Tutoriales Crédito Distribuidor-Proveedor</h6>
    </b-navbar>
    <b-breadcrumb :items="breadcrumbsItems"></b-breadcrumb>
    <div class="main-bg">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    breadcrumbsItems () {
      let breadcrumbs = [{
        text: 'Inicio',
        to: {name: 'Inicio'}
      }]
      switch (this.$route.meta.breadcrumb) {
        case 'videoplayer':
          if (this.$route.params.video.includes('pagador')) {
            breadcrumbs.push({
              text: 'Empresa pagadora - Proveedor',
              to: {name: 'Pagador'}
            })
            breadcrumbs.push('Video')
          }
          if (this.$route.params.video.includes('cobrador')) {
            breadcrumbs.push({
              text: 'Empresa cobradora - Distribuidor',
              to: {name: 'Cobrador'}
            })
            breadcrumbs.push('Video')
          }
          if (this.$route.params.video === 'intro-terminos') {
            breadcrumbs.push({
              text: 'Introducción términos importantes',
              to: {name: 'Inicio'}
            })
          }
          if (this.$route.params.video === 'intro-procesos') {
            breadcrumbs.push({
              text: 'Introducción procesos',
              to: {name: 'Inicio'}
            })
          }
          break
        case 'Inicio':
          break
        default:
          breadcrumbs.push({
            text: this.$route.meta.breadcrumb,
            to: {name: this.$route.name}
          })
          break
      }
      return breadcrumbs
    }
  }
}
</script>

<style>
  @import '~bootstrap/dist/css/bootstrap.css';
</style>
<style>
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>

<style>
@font-face {
  font-family: 'Prelo-Book';
  font-style: normal;
  font-weight: 400;
  src: url("/fonts/Prelo-Book.woff") format("woff"); }

@font-face {
  font-family: 'PreloSlab-Book';
  font-style: normal;
  font-weight: 400;
  src: url("/fonts/PreloSlab-Book.woff") format("woff"); }

#app {
  font-family: 'Prelo-Book';
  min-height: 100vh;
  font-size: 20px;
}

h1, h2, h3, h4, h5, h6, .slab {
  font-family: PreloSlab-Book !important;
}

a:hover {
  text-decoration: none !important;
  font-weight: 600 !important;
}

.first {
  font-size: 2.5rem;
}

.second {
  font-size: 1.75rem;
  font-weight: 600;
}

.navbar {
    background: #fff;
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
}

.navbar-title {
  font-size: 2rem;
  font-weight: 600;
}

.breadcrumb {
    background: #FFDD00 !important;
    color: #0f265c !important;
    margin-bottom: 0 !important;
    border-radius: 0 !important;
}
.breadcrumb-item, .breadcrumb-item a {
  color: #0f265c !important;;
}
.breadcrumb-item.active {
    color: #605e73 !important;
    font-weight: 600;
}

.main-bg {
  position: relative;
  height: calc(100vh - 140px);
  overflow-y: scroll;
  width: 100%;
  background: url('/bg.png') no-repeat center;
  background-size: cover;
}

.btn:active,.btn:focus {
    outline: none!important;
    border: none!important;
    box-shadow: none!important
}

.yellow {
    color: #fd0!important
}

.blue {
    color: #0f265c!important
}

.gray {
    color: #675c53!important
}

.card {
    border-radius: 0 0 0 25px;
    border: none
}

.card-header {
    border-bottom: none
}

.process-wrapper {
    width: 100%;
    height: 4rem;
    background: url(/button.svg) no-repeat 0 #ffdc00;
    background-size: auto 100%;
    border-radius: 3px;
    color: #0f265c
}

.action {
    font-size: 1.2rem;
    font-family: Prelo Slab
}

.action,ol {
    color: #0f265c
}

ol {
    font-weight: 600
}
.menu-block {
  border: 4px solid #fd0;
  background: #fd0;
  border-radius: 0 0 0 25px;
  padding: 2rem 3rem;
  width: 100%
}

.menu-block:hover {
    background: #fff
}

.menu-title-block {
    display: block;
    height: 100%
}

.menu-items-block {
    display: none
}
.menu-title {
    font-size: 2rem;
    line-height: 1.2
}

.items-title-container {
    background: #fd0;
    margin: -2rem -3rem 0;
    margin-top: -2rem;
    margin-left: -3rem;
    margin-right: -3rem;
    padding: .5rem 2rem
}

.items-title {
    font-size: 1.5rem
}

a.items-title {
    color: #0f265c
}

.menu-1:hover .menu-title-block {
    display: none
}

.menu-1:hover .menu-items-block {
    display: block
}

a.items-title:hover {
    font-weight: 600
}
.caret {
  height: 1.5rem;
  fill: #FFDD00;
}
</style>
